import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="not-found-container" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            padding: '20px'
        }}>
            <h1 style={{ fontSize: '4rem', color: '#333', marginBottom: '20px' }}>404</h1>
            <h2 style={{ fontSize: '2rem', color: '#666', marginBottom: '20px' }}>Page Not Found</h2>
            <p style={{ 
                fontSize: '1rem', 
                color: '#888', 
                marginBottom: '30px',
                maxWidth: '500px'
            }}>
                Oops! The page you are looking for doesn't exist or has been moved.
            </p>
            <Link to="/"  className='not-found-btn' >
                Go to Home
            </Link>
        </div>
    );
};

export default NotFound;